<template>
  <section class="tw-space-y-3">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
      <Heading level="h4">{{ t('decimator.slides_preview.title') }}</Heading>

      <Button color="semiTransparentWhite" outlined size="small" @click="toggle">
        {{ open ? t('decimator.slides_preview.hide') : t('decimator.slides_preview.load') }}
      </Button>
    </div>

    <template v-if="open">
      <Text v-if="failed || !previewUrl" class="tw-font-black tw-text-orange">
        {{ t('decimator.slides_preview.unavailable') }}
      </Text>

      <img
        v-else
        ref="previewImg"
        :src="previewUrl"
        :alt="t('decimator.slides_preview.title')"
        class="tw-w-full tw-rounded-[12px] tw-bg-black/30"
        @error="failed = true"
      />
    </template>
  </section>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed, onBeforeUnmount, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { Button, Heading, Text } from '@slideslive/fuse-kit/vue';

import useStateStore from '@/stores/state';
import toBrowserHost from '@/utils/station_url';

// ATEM multiview window 5 is the slides input.
const PREVIEW_PATH = '/streams/multiview?width=1344&q=60&fps=12&idx=5';

const { t } = useI18n();

const { state } = storeToRefs(useStateStore());

const open = ref(false);
const failed = ref(false);
const previewImg = ref(null);

const previewUrl = computed(() => {
  const nate = state.value?.data?.nate;
  if (nate?.status !== 'running' || !nate?.api_url) return null;

  return `${toBrowserHost(nate.api_url, state.value?.data?.app?.host_url).replace(/\/$/, '')}${PREVIEW_PATH}`;
});

// Chrome keeps an MJPEG stream open after the img leaves the page, so clear its src to stop the data.
function stopStream() {
  if (previewImg.value) previewImg.value.src = '';
}

function toggle() {
  if (open.value) stopStream();
  open.value = !open.value;
  failed.value = false;
}

onBeforeUnmount(stopStream);
</script>
